<template>
  <div
    class="pack_selector_container categories gap-10 lg-hide"
    v-dragscroll
    :class="[currentGameSlug]"
  >
    <NuxtLinkLocale
      :to="`/${currentGameSlug}`"
      exact-active-class="active"
      class="pack_selector justify-start gap-10"
    >
      <BmServiceIcon
        v-if="['path-of-exile-2-boost'].includes(currentGameSlug)"
      />
      <h3 class="white-space-no medium-l font-family-2 pack-title f-w-500">
        {{ $t("new.services") }}
      </h3>
    </NuxtLinkLocale>
    <div
      class="d-flex-column justify-start lg-col-to-row gap-0 pack_selector_parent"
      v-for="pack in packs"
      :key="pack"
    >
      <div class="d-flex-column justify-start lg-col-to-row gap-10">
        <component
          :is="pack.child_packs.length <= 0 ? defineNuxtLink({}) : 'div'"
          class="d-flex-row flex-1 pack_selector space-between"
          role="button"
          :to="`/${locale}/${currentGameSlug}/${pack.slug}`"
          :class="[currentOpenDrop === slug && 'active']"
          @click.stop="pack.child_packs.length > 0 ? openList(pack.slug) : null"
        >
          <div class="d-flex-row justify-start flex-9">
            <CurrenciesIcon
              v-if="pack.slug === 'path-of-exile-2-currency-boost'"
            />
            <PvEIcon v-if="pack.slug === 'path-of-exile-2-leveling-boost'" />
            <PvPIcon v-if="pack.slug === 'path-of-exile-2-campaign-boost'" />
            <TrialIcon
              v-if="pack.slug === 'path-of-exile-2-ascension-trials-boost'"
            />
            <h3
              class="white-space-no medium-l font-family-2 pack-title f-w-500"
            >
              {{ pack.short_title }}
            </h3>
          </div>

          <PlusMinusIcon
            :class="[currentOpenDrop === pack.slug && 'minus']"
            v-if="pack.child_packs?.length > 0"
          />
        </component>
      </div>

      <!-- <p class="t-white">{{ currencies(pack.slug) }}</p> -->
      <ul
        class="mmo_category_list"
        :class="[isCurrencyOpen && 'opened']"
        v-if="currencies(pack.slug).length > 0"
      >
        <li v-for="childPack in currencies(pack.slug)" :key="childPack.id">
          <button
            @click="
              navgiate(
                `/${currentGameSlug}/${pack.slug}?active_currency=${childPack.slug}`
              )
            "
            :class="[
              'height-36 other nest_pack_selector full-width justify-start t-light medium-l font-family-2 f-w-500 b-radius-6 white-space-no',
              { 'router-link-active': isRouteActive(childPack.slug) },
            ]"
          >
            {{ childPack.title }}
          </button>
        </li>
      </ul>

      <ul
        class="mmo_category_list"
        :class="[isParentOpened(pack.slug, pack.child_packs) && 'opened']"
        v-if="pack.child_packs.length > 0"
      >
        <li v-for="childPack in pack.child_packs" :key="childPack.id">
          <NuxtLinkLocale
            :to="`/${currentGameSlug}/${pack.slug}/${childPack.slug}`"
            class="height-36 other nest_pack_selector full-width justify-start t-light medium-l font-family-2 f-w-500 b-radius-6"
          >
            {{ childPack.short_title }}
          </NuxtLinkLocale>
        </li>
      </ul>
    </div>

    <TpReviews class="xl-hide" v-if="!$isMobile()" />
  </div>

  <div class="d-flex-column above-lg-hide gap-10">
    <!-- <div
      class="pack_selector_dropdown d-flex-row above-lg-hide"
      v-click-outside="closeOutside"
      :class="[currentGameSlug]"
    >
      <button
        class="selector_btn medium height-48 b-radius-6 full-width space-between medium-xl font-family-2 f-w-500"
        :class="[isOpen && 'opened']"
        @click.stop="toggleDrop"
        v-if="activePack"
      >
        {{ activePack }}
        <chev-right />
      </button>

      <transition name="slide-fade-top">
        <div
          class="d-flex-column justify-start align-start packs_list gap-18"
          v-if="isOpen"
        >
          <NuxtLinkLocale
            :to="getUrl(pack)"
            v-for="(pack, index) in otherPacks"
            @click.stop="closeOutside"
            class="medium-xl font-family-2 t-light routes d-flex-column align-start justify-start"
          >
            {{ pack.short_title }}
            <hr class="horizontal" v-if="index !== otherPacks.length - 1" />
          </NuxtLinkLocale>
        </div>
      </transition>
    </div> -->
    <CalculatorsCommonpickersPackBreadCrumb v-if="showBread && $isMobile()" />
    <TpReviews class="above-xl-hide" v-if="$isMobile()" />
  </div>
</template>

<script setup>
import BmServiceIcon from "~/components/icons/BmServiceIcon.vue";
import TpReviews from "~/components/common/sections/boosting/TpReviews.vue";
import CurrenciesIcon from "~/components/icons/CurrenciesIcon.vue";
import PvPIcon from "~/components/icons/wow/PvPIcon.vue";
import PvEIcon from "~/components/icons/wow/PvEIcon.vue";
import TrialIcon from "~/components/icons/TrialIcon.vue";
import PlusMinusIcon from "~/components/icons/PlusMinusIcon.vue";
import ChevRight from "~/components/icons/ChevRight.vue";
const { currentGameSlug, currentGamePackSlug } = useGameComposable();
const isOpen = ref(false);

const props = defineProps({
  showBread: {
    default: true,
  },
});
const router = useRouter();
const route = router.currentRoute;
const gameStore = useGameStore();
const { t, locale } = useI18n();
const localePath = useLocalePath();
const currentOpenDrop = ref("");

const packs = computed(() => {
  if (gameStore.getGamePacks?.length > 0) {
    return gameStore.getGamePacks;
  }
  return [];
});
const isParentOpened = (slug, childPacks) => {
  if (currentOpenDrop.value == slug) return true;

  return false;
};

const toggleDrop = () => {
  isOpen.value = true;
};
const closeOutside = () => {
  if (isOpen.value) {
    isOpen.value = false;
  }
};

const getUrl = (pack) => {
  if (pack?.is_service) return `/${currentGameSlug}`;

  if (pack?.is_query)
    return `/${currentGameSlug}/${currentGamePackSlug}?active_currency=${pack.slug}`;

  return `/${currentGameSlug}/${pack.slug}`;
};

const activePack = computed(() => {
  if (!route.value?.params?.gamePackSlug) {
    return t("new.services");
  }
  const packSlug = route.value.params?.gamePackSlug;
  const activePacks = gameStore.getGamePacks.find(
    (pack) => pack.slug === packSlug
  );
  if (activePacks) {
    return activePacks.short_title;
  }
  // else {
  //   const category = gameCategories.value?.find(
  //     (cate) => cate.slug === packSlug
  //   );
  //   if (category) {
  //     return category.short_title;
  //   }
  // }
  return "";
});

const otherPacks = computed(() => {
  if (activePack.value !== t("new.services")) {
    let packs = gameStore.getGamePacks.filter(
      (packs) => packs.short_title !== activePack.value && !packs.parent_pack_id
    );
    // console.log(currentGamePackSlug);
    let mapCurrencies = [];
    if (currentGamePackSlug === "path-of-exile-2-currency-boost") {
      mapCurrencies = [...currencies(currentGamePackSlug)]?.map((currency) => {
        return {
          is_query: true,
          slug: currency.slug,
          short_title: currency.title,
        };
      });
    }
    // if(activePack.val ==)
    packs = [
      {
        short_title: t("new.services"),
        is_service: true,
      },
      ...mapCurrencies,
      ...packs,
    ];
    return packs;
  }

  if (activePack.value) {
    return gameStore.getGamePacks.filter(
      (packs) => packs.short_title !== activePack.value && !packs.parent_pack_id
    );
  }
  return gameStore.getGamePacks;
});

const openList = (slug) => {
  const p = route.value?.fullPath;
  if (slug !== currentOpenDrop.value) {
    if (!p.includes(slug)) {
      router.push(localePath(`/${currentGameSlug}/${slug}`));
    }
    currentOpenDrop.value = slug;
  } else {
    currentOpenDrop.value = "";
  }
};

const currencies = (gamePackSlug) => {
  if (gamePackSlug === "path-of-exile-2-currency-boost") {
    return gameStore.getGamePack?.prices || [];
  }
  return [];
};
const p = route.value?.fullPath;

if (p.includes("path-of-exile-2-leveling-boost")) {
  currentOpenDrop.value = "path-of-exile-2-leveling-boost";
}

const isRouteActive = (id) => {
  return route.value.query?.active_currency === id;
};
const navgiate = (path) => {
  router.push(localePath(path));
};
const isCurrencyOpen = computed(() => {
  const currentRoute = route.value;
  if (
    currentGamePackSlug === "path-of-exile-2-currency-boost" &&
    currentRoute.query?.active_currency
  )
    return true;
  return false;
});
</script>

<style lang="scss">
.pack_selector_dropdown {
  &.path-of-exile-2-boost {
    .selector_btn {
      border: 1px solid var(--path-of-exile);
      background-color: var(--path-of-exile-opace);
    }
  }
  &.fc-boost {
    .selector_btn {
      border: 1px solid var(--fc-25);
      background-color: var(--fc-boost-opace);
    }
  }
}
</style>
